import React from "react";
import classNames from "classnames";

import "./chip.scss";

export interface IChipProps {
  label?: string;
  icon?: React.ReactNode;
  iconSize?: number;
  iconPosition?: "left" | "right";
  size?: "sm" | "md";
  selected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  className?: string;
}

export const Chip: React.FC<IChipProps> = ({
  label,
  icon,
  iconSize,
  iconPosition = "left",
  size = "sm",
  selected = false,
  disabled = false,
  onClick,
  className,
}) => {
  const isIconOnly = Boolean(icon && !label);
  const iconTrailing = iconPosition === "right" && Boolean(icon && label);

  const iconEl =
    icon &&
    (
      <span className="ui-chip__icon" aria-hidden="true">
        {icon}
      </span>
    );

  const labelEl = label && <span className="ui-chip__label">{label}</span>;

  const chipStyle =
    iconSize != null
      ? ({ "--chip-icon-size": `${iconSize}px` } as React.CSSProperties)
      : undefined;

  return (
    <button
      type="button"
      style={chipStyle}
      className={classNames("ui-chip", className, {
        "ui-chip--sm": size === "sm",
        "ui-chip--md": size === "md",
        "ui-chip--selected": selected,
        "ui-chip--icon-only": isIconOnly,
        "ui-chip--icon-trailing": iconTrailing,
      })}
      aria-pressed={selected}
      disabled={disabled}
      onClick={onClick}
    >
      {isIconOnly ? (
        iconEl
      ) : iconTrailing ? (
        <>
          {labelEl}
          {iconEl}
        </>
      ) : (
        <>
          {iconEl}
          {labelEl}
        </>
      )}
    </button>
  );
};

export default Chip;
